module.exports = __webpack_public_path__ + "static/media/calicon.1d2037a5.svg";